import { render } from "./QuestionAdd.vue?vue&type=template&id=161602f3"
import script from "./QuestionAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/question/QuestionAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "161602f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('161602f3', __exports__)) {
    api.reload('161602f3', __exports__)
  }
  
  module.hot.accept("./QuestionAdd.vue?vue&type=template&id=161602f3", () => {
    api.rerender('161602f3', render)
  })

}


export default __exports__